import { Flex, Modal, Text } from '@jisr-hr/design-system'
import FAICon from 'components/fontawesome/FAICon'
import FilePreview from './FilePreview'

import styles from './styles.module.css'
import { FilePreviewModalTypes } from './types'

const FilePreviewModal = ({
  url,
  open,
  onClose,
  title,
  handleDownload,
  handlePreviewLetter,
}: FilePreviewModalTypes): JSX.Element => (
  <Modal
    isOpen={open}
    onClose={onClose}
    variant="centerDialog"
    width="85%"
    height="85%"
    modalContentStyle={{ objectFit: 'fill', position: 'relative' }}
    content={
      <>
        <Flex
          justifyBetween
          itemsCenter
          className={styles.previwModalHeader}
        >
          {handleDownload && (
            <FAICon
              icon="download"
              style={{ cursor: 'pointer' }}
              onClick={handleDownload}
            />
          )}
          {url && (
            <a
              download
              href={url}
              rel="noopener noreferrer"
              target="_blank"
              style={{ color: 'unset' }}
            >
              <FAICon icon="download" />
            </a>
          )}

          <Text
            typography="title"
            weight="bold"
          >
            {title}
          </Text>

          <Flex
            itemsCenter
            justifyCenter
            style={{
              width: 40,
              height: 40,
              borderRadius: 8,
              backgroundColor: 'var(--color-natural-gray-lightest-2-new)',
            }}
          >
            <FAICon
              size="lg"
              icon="close"
              color="var(--color-natural-gray-dark-new)"
              style={{ cursor: 'pointer' }}
              onClick={onClose}
            />
          </Flex>
        </Flex>
        <FilePreview
          url={url}
          handlePreviewLetter={handlePreviewLetter}
        />
      </>
    }
  />
)

export default FilePreviewModal
